import angular from 'angular';
import tableGridBodyComponent from './tableGridBody.component';
import StringUtils from '../../common/stringUtils/stringUtils';

let tableGridBodyModule = angular.module('tableGridBody', [
  StringUtils.name
]).directive('tableGridBody', tableGridBodyComponent);

export default tableGridBodyModule;



// WEBPACK FOOTER //
// ./app/components/tableGridBody/tableGridBody.js